.backdrop {
  position: fixed;
  inset: 0;
  z-index: var(--z-modal);
  background: var(--color-overlay);
  display: grid;
  place-items: center;
  padding: var(--space-4);
  animation: fade 0.15s var(--ease);
}
.panel {
  width: 100%;
  max-height: calc(100dvh - 32px);
  display: flex;
  flex-direction: column;
  background: var(--color-surface);
  color: var(--color-text);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-lg);
  animation: rise 0.2s var(--ease);
}
.panel:focus {
  outline: none;
}
.sm {
  max-width: 420px;
}
.md {
  max-width: 560px;
}
.lg {
  max-width: 800px;
}
.header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-6) var(--space-6) var(--space-3);
}
.title {
  font-size: var(--text-xl);
  font-weight: 700;
}
.desc {
  color: var(--color-text-muted);
  font-size: var(--text-sm);
  margin-block-start: 4px;
}
.body {
  padding: var(--space-3) var(--space-6) var(--space-6);
  overflow-y: auto;
}
.footer {
  display: flex;
  justify-content: flex-end;
  gap: var(--space-2);
  padding: var(--space-4) var(--space-6);
  border-block-start: 1px solid var(--color-border);
}
@keyframes fade {
  from {
    opacity: 0;
  }
}
@keyframes rise {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.98);
  }
}
